import { render, staticRenderFns } from "./codemodal.vue?vue&type=template&id=2ec96f22&scoped=true"
import script from "./codemodal.vue?vue&type=script&lang=js"
export * from "./codemodal.vue?vue&type=script&lang=js"
import style0 from "./codemodal.vue?vue&type=style&index=0&id=2ec96f22&prod&scoped=true&lang=css"
import style1 from "./codemodal.vue?vue&type=style&index=1&id=2ec96f22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec96f22",
  null
  
)

export default component.exports